import React from 'react';
import PropTypes from 'prop-types';
import './App.scss';
import { CurrentSiteProvider, useContextCurrentSite } from 'contexts';
import { PropertiesProvider, useContextProperties } from 'contexts/properties';
import {
  FirebaseContext,
  firebaseService,
  firebaseServicePre
} from './dataProvider';
import RouterApp from './Router.App';

// Rediseño sites have subdomain removed from its document domain, replace properly to allow parent navigation
if (document.location.hash.indexOf('amp') === -1) {
  document.domain = document.domain.replace('www.', '');
}

const isAMP = document.location.hash.indexOf('amp') !== -1;

const initializeService = process.env.REACT_APP_STAGING
  ? firebaseServicePre
  : firebaseService;
window.atresmedia_elecciones_firebase =
  window.atresmedia_elecciones_firebase || initializeService();

const envLabel = process.env.REACT_APP_STAGING ? 'pre' : 'pro';

const AppContainer = ({ children }) => {
  const { currentSite } = useContextCurrentSite();
  const { params } = useContextProperties();
  const { elections } = params;
  return (
    <div
      className={`App ${currentSite} ${envLabel} app-elecciones ${
        elections.name
      } ${isAMP ? 'isAMP' : ''}`}
    >
      {children}
    </div>
  );
};

AppContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const App = ({ entry }) => (
  <CurrentSiteProvider>
    <PropertiesProvider>
      <AppContainer>
        <FirebaseContext.Provider value={window.atresmedia_elecciones_firebase}>
          <RouterApp entry={entry} />
        </FirebaseContext.Provider>
      </AppContainer>
    </PropertiesProvider>
  </CurrentSiteProvider>
);

App.propTypes = {
  entry: PropTypes.string.isRequired
};

export default App;
